import React from 'react';
import classNames from 'classnames';
import type { SelectProps } from './types';

const Select: React.FC<SelectProps> = ({
  children,
  className,
  label,
  disabled,
  id,
  name,
  autoComplete,
  error,
  value,
  required,
  hideLabel,
  onChange,
  register
}: SelectProps) => {
  const inputClasses = classNames(
    'bg-rt-input border border-white border-opacity-30 h-12 px-4 text-white w-full appearance-none | c-dropdown'
  );

  const wrapperClasses = classNames(className, 'mb-3');

  const registerProps = register ? { ...register(id, { required }) } : {};

  return (
    <div className={wrapperClasses}>
      {label ? (
        <label
          className={`text-white mb-2 block text-sm ${hideLabel ? 'sr-only' : ''}`}
          htmlFor={id}>
          {label}
        </label>
      ) : null}
      <select
        className={inputClasses}
        aria-describedby={error ? `${name}-error` : undefined}
        disabled={disabled}
        id={id}
        name={name}
        autoComplete={autoComplete}
        defaultValue={value}
        onChange={onChange}
        // ref={inputRef}
        {...registerProps}>
        {children}
      </select>
      {error ? (
        <span role="alert" className="text-sm text-red-500" id={`${name}-error`}>
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default Select;
